export default {
  container: { margin: 'auto' },
  timeline: {
    listStyle: 'none',
    padding: '20px 0 20px',
    position: 'relative',
    margin: 'auto',
  },
  item: {
    marginBottom: '20px',
    position: 'relative',
    width: '100%',
  },
  gridItem: { padding: 5 },
};
